export const uk = {
    BYN: 'Белорусские рубли',
    CHF: 'Швейцарские франки',
    EUR: 'Евро',
    KZT: 'Казахстанские тенге',
    RUB: 'Российские рубли',
    TRY: 'Турецкие лиры',
    UAH: 'Украинские гривны',
    USD: 'Доллары США',
    UZS: 'Узбекские сумы'
};
